import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { WebSocketLink } from '@apollo/client/link/ws';
import { RetryLink } from '@apollo/client/link/retry';
import { setContext } from '@apollo/client/link/context';
import { SubscriptionClient } from 'subscriptions-transport-ws'
import io from 'socket.io-client';
import Cookies from 'universal-cookie';
import { scanUser } from '../pages/users/partials/log';
import { expiredUser } from '../pages/users/partials/logout';
import { evCompareCacheListing } from '../assets/javascripts/function';

const cookies = new Cookies();

const getToken = () => {
  const Retoken: string = cookies.get('token');
  return Retoken;
};

const withRetries = new RetryLink({
  delay: {
    max: 30 * 1000,
  },
  attempts: (count, operation, error) => {
    if (error && error.toString().indexOf('aborted') !== -1) {
      console.log(`error ${operation.operationName} ${error}`)
      count = 0
      return false
    } else {
      if (count >= 3) {
        console.log(`Retrying operation ${operation.operationName} (Attempt ${count})`)
        intrigueToken()
        if (count >= 5) return false
      }
    }
    
    return !!error
  }
});

const link = createHttpLink({ uri: process.env.REACT_APP_GRAPHQL_URL });

const wsClient = new SubscriptionClient('wss://apollo-subscription.forstok.com/graphql', {
  reconnect: true,
  timeout: 20000
});
const wsLink = new WebSocketLink(wsClient);

wsClient.onConnected(() => console.log('websocket connected!!'));
wsClient.onDisconnected(() => console.log('websocket disconnected!!'));
wsClient.onReconnected(() => console.log('websocket reconnected!!'));

const intrigueToken = () => {
  const token = getToken();
  if (!token) {
    const callbackToken = () => {
      expiredUser()
    };
    scanUser().then((result) => {
      if (!result) {
        callbackToken();
      }
    }).catch(error => {
      console.error('Error Checking Login', error);
      callbackToken();
    });
  }
};

const forstokHttpLink = ApolloLink.from([
  withRetries,
  link
]);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  forstokHttpLink,
);

const forstokAuthLink = setContext((_, { headers }) => {
  const token = getToken();
  intrigueToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    }
  };
});

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        warehouses: {
          merge(existing, incoming){
            return incoming
          }
        },
        orders: {
          merge(existing, incoming){
            return {...existing, ...incoming}
          }
        },
        profileActivities: {
          merge(existing, incoming){
            return {...existing, ...incoming}
          }
        },
        products: {
          merge(existing, incoming){
            return {...existing, ...incoming}
          }
        },
        variants: {
          merge(existing, incoming){
            return {...existing, ...incoming}
          }
        },
        listings: {
          merge(existing, incoming, { args, readField }){
            return evCompareCacheListing(existing, incoming, args, readField) ? {...existing, ...incoming} : existing
          }
        },
        listingBrands: {
          merge(existing, incoming){
            return {...existing, ...incoming}
          }
        },
        qtyInventories: {
          merge(existing, incoming){
            return {...existing, ...incoming}
          }
        },
        listingTotalSkus: {
          merge(existing, incoming){
            return {...existing, ...incoming}
          }
        },
      }
    },
    Warehouses: {
      keyFields: ['id'],
    },
    Accounts: {
      keyFields: ['id', ['name']],
    },
    WarehouseInventoryPromotion: {
      keyFields: false
    },
    WarehouseInventoryReservedOrder: {
      keyFields: false
    },
    Bin: {
      keyFields: false
    },
    Channels: {
      keyFields: ['navbarId']
    },
    InputGetVariantWarehousePayload: {
      keyFields: false
    }
  }
});

export const client = new ApolloClient({
  link: forstokAuthLink.concat(splitLink),
  cache,
  queryDeduplication: false
});

export const socket = io('wss://socket.forstok.com');